import { useEffect, useRef } from 'react';

import { Flex } from '@chakra-ui/react';
import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { IntentDropdown } from 'Deer/intent/Reviews/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import ReviewsListView from 'screens/performanceReview/manageAndInsights/ReviewActionPlan/ReviewsListView';
import { checkActionPlanFeatureEnabled } from 'utils/helpers/featureFlags';

import moduleNotEnabled from 'assets/assetsV1/illustrations/deerIllustrations/moduleNotEnabled.svg';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

const TEAM_COHORT = { id: -2, name: 'My Team', type: 'MY_TEAM' };

const DirectReportsReviewsActionPlan = () => {
  const dispatch = useDispatch();
  const gridRef = useRef();
  const { moduleName } = useOrganisationSettings();

  const applicableL2DirectReportsModules = getApplicableL2MyTeamModules('directReports', moduleName);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Direct team-reviews-plan-of-action',
      },
    });
  }, []);

  useEffect(() => {
    dispatch(setSelectedView(TEAM_COHORT));

    return () => {
      dispatch(setSelectedView({}));
    };
  }, [dispatch]);

  if (!checkActionPlanFeatureEnabled()) {
    return (
      <Flex h="80vh" justifyContent="center" alignItems="center">
        <EmptyScreen
          heading="Growth Plan is not available"
          description="This feature is currently disabled for your organisation."
          illustrationSrc={moduleNotEnabled}
        />
      </Flex>
    );
  }

  return (
    <Layout
      Filters={
        <IntentDropdown
          gridRef={gridRef}
          breadcrumbs={{
            items: [
              {
                label: 'Direct Team',
                to: applicableL2DirectReportsModules[0]?.value,
              },
            ],
            page: {
              label: 'Reviews',
              to: '',
            },
          }}
        />
      }
    >
      <ReviewsListView gridRef={gridRef} />
    </Layout>
  );
};

export default DirectReportsReviewsActionPlan;
